













































import Vue from 'vue';

export default Vue.extend({
    name: 'HelpDomains',
    created() {
        this.$store.state.routeLoaded = true;
    }
})
